'use strict';

// エラーダイアログに入力するエラーオブジェクト
let error;
// モーダルコンテンツ
let $modalContent;

function keydownHandler (e) {
    if (e.keyCode == 13) {
        $modalContent.find('.btn-submit').click();
        return false;
    } else if (e.keyCode == 27) {
        $modalContent.find('.btn-cancel').click();
        $modalContent.find('.btn-close').click();
        return false;
    }
};

/**
 * update product list
 * @param {hasBuyNow} hasBuyNow -hasBuyNow
 * @param {hasPreOrder} hasPreOrder -hasPreOrder
 * @param {hasPreOhasSinglePurchaserder} hasSinglePurchase -hasSinglePurchase
 */
function updateProductList(hasBuyNow, hasPreOrder, hasSinglePurchase) {
    var html = 'No items';
    if (!hasBuyNow) {
        $('.buy_now-list').empty();
        $('.buy_now-list').append(html);
        $('.buy_now-total').remove();
    }

    if (!hasSinglePurchase) {
        $('.single_purchase-list').empty();
        $('.single_purchase-list').append(html);
    }

    if (!hasPreOrder) {
        $('.pre_order-list').empty();
        $('.pre_order-list').append(html);
    }
}

/**
 * update MiniCart
 * @param {quantityTotal} quantityTotal -quantityTotal
 */
 function updateMiniCart(quantityTotal) {
    if (quantityTotal <= 0) {
        $('.cmn-header__main__menu__cart__number').hide();
    } else {
        $('.cmn-header__main__menu__cart__number').show();
        if ($('.cmn-header__main__menu__cart__number').length) {
            $('.cmn-header__main__menu__cart__number').empty();
            var html = '';
            if (quantityTotal < 100) {
                html = quantityTotal;
            } else {
                html = '99+';
            }
            $('.cmn-header__main__menu__cart__number').append(html);
        }
    }
}

/**
 * change in stock total
 * @param {target} this -this
 * @param {subTotal} subTotal -subTotal
 */
function changeSubTotal(target, subTotal) {
    var subTotalContent = target.parents('.cart__product-list-article').find(".cart__product-list-article-total-price");
    if(subTotalContent.length) {
        var html = '';
        subTotalContent.empty();
        html = subTotal;
        subTotalContent.append(html);
    }
}

/**
 * change all in stock items subtotal
 * @param data data -data
 */
function changeAllSubTotal(data) {
    for (let i = 0; i < data.items.length; i++) {
        var targetSelector = '.cart__product-list-article-total-price-' + data.items[i].id;
        if($(targetSelector).length) {
            $(targetSelector).empty().append(data.items[i].priceTotal.price);
        }
    }
}

/**
 * change all discounts items total
 * @param data data -data
 */
function changeAllDiscounts(data) {
    data.discountedProducts.forEach(product => {
        let targetSelector = `.discount-amount.cart__product-list-article-discount-${product.id}`;
        let $discountElement = $(targetSelector);

        if ($discountElement.length) {
            let $parent = $discountElement.parent();
            let $currentPrice = $parent.find('span.current-price');
            let $priceBefore = $parent.find('s.price-before');

            // Update the sale price
            $currentPrice.text(product.targetAjustedUnitAmount);

            if (!product.hasDiscount) {
                $discountElement.add($priceBefore).addClass('hidden');
            } else {
                $discountElement.removeClass('hidden').find('span').text(product.targetDiscountedUnitAmount);
                $priceBefore.removeClass('hidden');
            }
        }
    });
}

/**
 * change in stock total
 * @param {buyNowItemsTotalPrice} buyNowItemsTotalPrice -buyNowItemsTotalPrice
 */
function changeButNowTotal(buyNowItemsTotalPrice) {
    if($('.cart__total-price').length) {
        var html = '';
        $('.cart__total-price').empty();
        html = 'Total: ' + buyNowItemsTotalPrice;
        $('.cart__total-price').append(html);
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * displa popup of Error
 * @param {Object} err - Error data
 */
function createErrorNotification(errData) {
        // 警告メッセージダイアログ
        var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
        dialog += '<div class="modal-paypal__description">' + errData.responseJSON.errorMessage + '</div>';
        dialog += '<ul class="modal-paypal-buttons">';
        dialog += '<li><button type="button" class="button-gray btn-close">Close</button></li>';
        dialog += '</ul>';
        dialog += '</div>';

        $.magnificPopup.open({
            items: {
                src: dialog,
                type: 'inline'
            },
            mainClass: 'mfp-fade',
            removalDelay: 600,
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    $modalContent = $(this.content);
                    $modalContent.on('click', '.btn-close', function() {
                        $.magnificPopup.close();
                        $(document).off('keydown', keydownHandler);
                    });

                    $(document).on('keydown', keydownHandler);
                }
            }
        });
}

/**
 * BillingAgreementIDまたはデフォルトアドレスがない場合のダイアログ
 * @param {Object} errData - Error data
 * @param {string} buttonText - submitボタンに表示するメッセージ
 */
function noSettingDaialog(errData, buttonText) {
    // 警告メッセージダイアログ
    var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
    dialog += '<div class="modal-paypal__description">' + errData.responseJSON.errorMessage + '</div>';
    dialog += '<ul class="modal-paypal-buttons">';
    dialog += '<li><button type="button" class="button-basic btn-submit" onclick="location.href=\'' + errData.responseJSON.redirectUrl + '\'">'+ buttonText +'</button></li>';
    dialog += '<li><button type="button" class="button-gray btn-close">CANCEL</button></li>';
    dialog += '</ul>';
    dialog += '</div>';

    $.magnificPopup.open({
        items: {
            src: dialog,
            type: 'inline'
        },
        mainClass: 'mfp-fade',
        removalDelay: 600,
        closeOnBgClick: true,
        callbacks: {
            open: function() {
                $modalContent = $(this.content);
                $modalContent.on('click', '.btn-close', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });
                $(document).on('keydown', keydownHandler);
            }
        }
    });
}

/**
 * チェックアウト事前チェックエラーハンドリング
 * @param {Object} err - Parameters to append
 */
function checkoutBeforeCheckErrorHandle(err) {
    // PreferredAddressがない場合
    if ('noPreferredAddress' in err.responseJSON
    && err.responseJSON.noPreferredAddress) {
        noSettingDaialog(err, 'Address Book');
        return;
    }

    // BillingAgreementIDがない場合
    if ('noBillingAgreement' in err.responseJSON
    && err.responseJSON.noBillingAgreement) {
        noSettingDaialog(err, 'SETUP');
        return;
    }

    if ('redirectUrl' in err.responseJSON
    && err.responseJSON.redirectUrl) {
        // リダイレクトURLがあればリダイレクト
        window.location.href = err.responseJSON.redirectUrl;
    } else {
        // エラーメッセージ表示
        createErrorNotification(err);
    }
}

/**
 * チェックアウトからエラーで戻された時のエラー文を表示する
 */
function showErrorDialog() {
    const errorArray = JSON.parse($('#errorArray').val() || 'null');
    if (errorArray === null) {
        // エラー情報がない場合はスキップする
        return;
    }
    const errorForPlaceOrder = errorArray[0];
    // 内部処理でのエラーの場合
    const dialogContent = `<div class="modal-base modal-paypal-wrapper jsModalContentOuter">
          <div class="modal-paypal__ttl">Checkout Failure</div>
          <div class="modal-paypal__description" style="text-align:left;padding-left:1em;padding-right:1em;">
              ${errorForPlaceOrder.message}
          </div>
          <ul class="modal-paypal-buttons">
          <li><button type="button" class="button-basic btn-close" onclick="$.magnificPopup.close();">Continue</button></li>
          </ul>
          </div>`;

    $.magnificPopup.open({
        items: {
            src: dialogContent,
            type: 'inline',
        },
        closeOnBgClick: false,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        enableEscapeKey: false,
        showCloseBtn: false,
        callbacks: {
            open() {
                const $content = $(this.content);

                $content.on('click', '.btn-close', () => {
                    $.magnificPopup.close();
                    // eslint-disable-next-line no-use-before-define
                    $(document).off('keydown', keydownHandler);
                });
                $(document).on('keydown', keydownHandler);
            },
        },
    });
}

module.exports = function () {

    // 商品削除
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();
        var button = $(this);
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        // 確認ダイアログ
        var dialog = '<div class="modal-base modal-paypal-wrapper jsModalContentOuter">';
        dialog += '<div class="modal-paypal__description"> Are you sure you want to remove this item from your cart? </div>';
        dialog += '<ul class="modal-paypal-buttons">';
        dialog += '<li><button type="button" class="button-basic btn-submit">CONFIRM</button></li>';
        dialog += '<li><button type="button" class="button-gray btn-cancel">CANCEL</button></li>';
        dialog += '</ul>';
        dialog += '</div>';

        $.magnificPopup.open({
            items: {
                src: dialog,
                type: 'inline'
            },
            mainClass: 'mfp-fade',
            removalDelay: 600,
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    $modalContent = $(this.content);
                    $modalContent.on('click', '.btn-submit', function() {
                        $.spinner().start();
                        $modalContent.spinner().start();
                        $.ajax({
                            url: url,
                            type: 'get',
                            dataType: 'json',
                            success: function (data) {
                                // 商品要素削除
                                button.parents('.cart__product-list-article').remove();
                                // 商品小計の修正
                                changeAllSubTotal(data.basket)
                                // disocuntの修正
                                changeAllDiscounts(data);
                                // BuyNow価格修正
                                changeButNowTotal(data.buyNowItemsTotalPrice.formatted);
                                // ミニカートの更新
                                updateMiniCart(data.quantityTotal);
                                // 商品がなくなった場合の制御
                                updateProductList(data.hasBuyNow, data.hasPreOrder, data.hasSinglePurchase);
                                $.magnificPopup.close();
                                $.spinner().stop();
                            },
                            error: function (err) {
                                error = err;
                                if (err.responseJSON.redirectUrl) {
                                    window.location.href = err.responseJSON.redirectUrl;
                                } else {
                                    $.magnificPopup.close();
                                }
                            }
                        });

                        $(document).off('keydown', keydownHandler);
                    });

                    $modalContent.on('click', '.btn-cancel', function() {
                        $.magnificPopup.close();
                        $(document).off('keydown', keydownHandler);
                    });
                    $(document).on('keydown', keydownHandler);
                },
                afterClose: function() {
                    if(error) {
                       createErrorNotification(error);
                       error = null;
                    }
                    $.spinner().stop();
                },
            }
        });
    });

    // 個数変更
    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $.spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                // 商品小計の修正
                changeAllSubTotal(data)
                // disocuntの修正
                changeAllDiscounts(data);
                // BuyNow価格修正
                changeButNowTotal(data.buyNowItemsTotalPrice.formatted);
                // ミニカートの更新
                updateMiniCart(data.quantityTotal);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    // 個別チェックアウト（事前チェック）
    $('body').on('click', '.button-checkout', function (e) {
        var productID = $(this).data('pid');
        var productStatus = $(this).data('pst');
        var url = $(this).data('action');

        var data = {
            pid: productID,
            pst: productStatus
        };

        $.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: data,
            success: function (data) {
                // チェックアウトページへリダイレクト
                window.location.href = data.redirectUrl;
            },
            error: function (err) {
                checkoutBeforeCheckErrorHandle(err);
                $.spinner().stop();
            }
        });
    });

    // BuyNowチェックアウト（事前チェック）
    $('body').on('click', '.button-checkout-buynow', function (e) {
        var productStatus = $(this).data('pst');
        var url = $(this).data('action');

        var data = {
            pst: productStatus
        };

        $.spinner().start();

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: data,
            success: function (data) {
                // チェックアウトページへリダイレクト
                window.location.href = data.redirectUrl;
            },
            error: function (err) {
                checkoutBeforeCheckErrorHandle(err);
                $.spinner().stop();
            }
        });
    });

    showErrorDialog();

};
